import { supabase, getActiveSchema } from '../../../../supabaseClient';
import { SleepLogSchema } from '@/types/zod.schemas';

/**
 * RECOVERY REPOSITORY
 * Specialized IO for sleep logs and recovery metrics.
 */

const getClient = () => {
    const schema = getActiveSchema();
    return supabase.schema(schema);
};

const SLEEP_LOG_COLUMNS = 'id, user_id, start_time, end_time, quality_rating, notes, created_at, updated_at';

export const RecoveryRepo = {
    async fetchSleepHistory(userId: string) {
        const { data, error } = await getClient()
            .from('sleep_logs')
            .select(SLEEP_LOG_COLUMNS)
            .eq('user_id', userId)
            .order('start_time', { ascending: false });

        if (data) {
            data.forEach(log => {
                const result = SleepLogSchema.safeParse(log);
                if (!result.success) {
                    console.warn("[RecoveryRepo] Invalid sleep log found:", result.error.format(), log);
                }
            });
        }
        return { data, error };
    },

    async fetchSleepLog(logId: string) {
        const { data, error } = await getClient()
            .from('sleep_logs')
            .select(SLEEP_LOG_COLUMNS)
            .eq('id', logId)
            .maybeSingle();

        if (data) SleepLogSchema.safeParse(data);
        return { data, error };
    },

    async insertSleepLog(payload: any) {
        const { data, error } = await getClient()
            .from('sleep_logs')
            .insert([payload])
            .select(SLEEP_LOG_COLUMNS)
            .maybeSingle();

        if (data) SleepLogSchema.safeParse(data);
        return { data, error };
    },

    async updateSleepLog(logId: string, payload: any) {
        const { data, error } = await getClient()
            .from('sleep_logs')
            .update(payload)
            .eq('id', logId)
            .select(SLEEP_LOG_COLUMNS)
            .maybeSingle();

        if (data) SleepLogSchema.safeParse(data);
        return { data, error };
    },

    async deleteSleepLog(logId: string) {
        return await getClient()
            .from('sleep_logs')
            .delete()
            .eq('id', logId);
    }
};
